import { render, staticRenderFns } from "./SightPP.vue?vue&type=template&id=fcb606e8&"
import script from "./SightPP.vue?vue&type=script&lang=js&"
export * from "./SightPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports